import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "grid grid-cols-3 text-gray-900" }
const _hoisted_3 = { class: "isolate mt-2 grid sm:grid-cols-7 grid-cols-1 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200" }
const _hoisted_4 = ["data-date", "onClick"]
const _hoisted_5 = { class: "hidden sm:block" }
const _hoisted_6 = ["datetime"]
const _hoisted_7 = { class: "text-gray-500 font-manrope text-xxs sm:text-xs my-2" }
const _hoisted_8 = { class: "h-4" }
const _hoisted_9 = { class: "font-mono" }
const _hoisted_10 = {
  key: 0,
  class: "h-4"
}
const _hoisted_11 = { class: "font-mono" }
const _hoisted_12 = {
  key: 1,
  class: "h-4"
}
const _hoisted_13 = { class: "font-mono" }
const _hoisted_14 = { class: "h-4 flex items-center justify-center" }
const _hoisted_15 = { class: "font-mono" }
const _hoisted_16 = { class: "flex sm:hidden items-center ml-2" }
const _hoisted_17 = ["datetime"]
const _hoisted_18 = { class: "ml-2 block" }
const _hoisted_19 = { class: "text-gray-500 font-manrope text-xs my-2 ml-2 flex justify-center" }
const _hoisted_20 = { class: "h-4 ml-2" }
const _hoisted_21 = { class: "font-mono" }
const _hoisted_22 = {
  key: 0,
  class: "h-4"
}
const _hoisted_23 = { class: "font-mono" }
const _hoisted_24 = {
  key: 1,
  class: "h-4"
}
const _hoisted_25 = { class: "font-mono" }
const _hoisted_26 = { class: "h-4 ml-2 flex items-center" }
const _hoisted_27 = { class: "font-mono" }

import {
  ArrowPathRoundedSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ExclamationTriangleIcon
} from '@heroicons/vue/20/solid'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import { calendarDayCount, calendarDays, dateObjectToServerDay, plusDays, weekStartOf } from '@/helpers/dates'


export default {
  __name: 'ProductionDayCalendar',
  props: {
  days: { type: Array, default: () => [] },
  current: { type: Date, required: true },
  hideNumbers: { type: Boolean, default: false },
  showUber: { type: Boolean, default: true },
  showSubscribers: { type: Boolean, default: true }
},
  emits: ['select', 'update:current', 'update:range'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

// Read inside the grid computed so a resize re-evaluates the 7-or-14 choice.
const width = ref(window.innerWidth)
const onResize = () => {
  width.value = window.innerWidth
}
onMounted(() => window.addEventListener('resize', onResize))
onBeforeUnmount(() => window.removeEventListener('resize', onResize))

const dates = computed(() => {
  // eslint-disable-next-line no-unused-expressions
  width.value
  return calendarDays(props.current, calendarDayCount())
})

const EMPTY_CELL = {
  total: null,
  orders: 0,
  pickups: 0,
  subscribers: 0,
  warning: false,
  locations: null,
  clickable: false
}
const cellsByDate = computed(() => Object.fromEntries(props.days.map(day => [day.date, day])))
const serverDay = dateObjectToServerDay
const cell = date => cellsByDate.value[serverDay(date)] || EMPTY_CELL

// The calendar owns the visible range; the page follows it to fetch and map data.
// Watching a string key (not the array) so a resize within the same bucket does not re-emit.
const rangeKey = computed(() => `${serverDay(dates.value[0])}|${serverDay(dates.value.at(-1))}`)
watch(
  rangeKey,
  () => {
    const list = dates.value
    emit('update:range', { from: serverDay(list[0]), to: serverDay(list.at(-1)), dates: list.map(serverDay) })
  },
  { immediate: true }
)

const weekStart = computed(() => weekStartOf(props.current))
const currentMonth = date =>
  weekStart.value.getMonth() === date.getMonth() && weekStart.value.getFullYear() === date.getFullYear()
const locationsLabel = total => (total === 1 ? 'location' : 'locations')
const currentDay = date =>
  new Date().getDate() === date.getDate() &&
  new Date().getMonth() === date.getMonth() &&
  new Date().getFullYear() === date.getFullYear()

const dayFormat = new Intl.DateTimeFormat('en-US', {
  day: 'numeric'
}).format
const weekdayFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'long'
}).format
const monthDayFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric'
}).format
const monthFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long'
}).format

const weekText = offset => monthDayFormat(plusDays(weekStart.value, offset)).replace(/ /g, '\u00a0')
const prevWeekText = computed(() => weekText(-7))
const nextWeekText = computed(() => weekText(7))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        "data-week": "prev",
        class: "-m-1.5 flex flex-none items-center p-1.5 text-gray-400 hover:text-gray-500 text-left",
        onClick: _cache[0] || (_cache[0] = $event => (emit('update:current', _unref(plusDays)(__props.current, -7))))
      }, [
        _createVNode(_unref(ChevronLeftIcon), {
          class: "h-5 w-5 mr-1",
          "aria-hidden": "true"
        }),
        _createTextVNode(" Week of " + _toDisplayString(prevWeekText.value), 1)
      ]),
      _createElementVNode("div", {
        "data-week": "today",
        class: "font-semibold cursor-pointer",
        onClick: _cache[1] || (_cache[1] = $event => (emit('update:current', new Date())))
      }, _toDisplayString(_unref(monthFormat)(weekStart.value)), 1),
      _createElementVNode("button", {
        type: "button",
        "data-week": "next",
        class: "-m-1.5 flex flex-none items-center justify-end p-1.5 text-gray-400 hover:text-gray-500 text-right",
        onClick: _cache[2] || (_cache[2] = $event => (emit('update:current', _unref(plusDays)(__props.current, 7))))
      }, [
        _createTextVNode(" Week of " + _toDisplayString(nextWeekText.value) + " ", 1),
        _createVNode(_unref(ChevronRightIcon), {
          class: "h-5 w-5 ml-1",
          "aria-hidden": "true"
        })
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-6 grid-cols-7 text-xs leading-6 text-gray-500 hidden sm:grid" }, [
      _createElementVNode("div", null, "S"),
      _createElementVNode("div", null, "M"),
      _createElementVNode("div", null, "T"),
      _createElementVNode("div", null, "W"),
      _createElementVNode("div", null, "T"),
      _createElementVNode("div", null, "F"),
      _createElementVNode("div", null, "S")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (day, i) => {
        return (_openBlock(), _createElementBlock("button", {
          key: day,
          "data-date": _unref(serverDay)(day),
          class: _normalizeClass(["py-2 px-1 hover:bg-gray-100 focus:z-10 flex sm:flex-col items-center", [
          cell(day).clickable ? 'cursor-pointer' : 'cursor-auto',
          currentMonth(day) ? 'bg-white' : 'bg-gray-50',
          currentDay(day) && 'font-semibold',
          currentMonth(day) && !currentDay(day) && 'text-gray-900',
          !currentMonth(day) && !currentDay(day) && 'text-gray-400',
          currentDay(day) && 'text-gray-900 ',
          i === 0 && 'sm:rounded-tl-lg',
          i === 6 && 'sm:rounded-tr-lg',
          i === dates.value.length - 7 && 'sm:rounded-bl-lg',
          i === dates.value.length - 1 && 'sm:rounded-br-lg'
        ]]),
          onClick: $event => (cell(day).clickable && emit('select', _unref(serverDay)(day)))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("time", {
              datetime: _unref(serverDay)(day),
              class: _normalizeClass([
              'mx-auto flex h-7 w-7 items-center justify-center rounded-full',
              currentDay(day) ? 'bg-gray-900 text-white' : 'bg-gray-200'
            ])
            }, _toDisplayString(_unref(dayFormat)(day)), 11, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["font-mono", __props.hideNumbers && 'blur-sm'])
              }, _toDisplayString(cell(day).total ?? '-'), 3),
              _createElementVNode("div", _hoisted_8, [
                (cell(day).orders)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(cell(day).orders), 1),
                      _createTextVNode(" order" + _toDisplayString(cell(day).orders !== 1 ? 's' : ''), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (cell(day).locations)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(cell(day).locations.with), 1),
                    _createTextVNode(" of " + _toDisplayString(cell(day).locations.of) + " " + _toDisplayString(locationsLabel(cell(day).locations.of)), 1)
                  ]))
                : (__props.showUber && cell(day).pickups)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(cell(day).pickups), 1),
                      _createTextVNode(" pickup" + _toDisplayString(cell(day).pickups !== 1 ? 's' : ''), 1)
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (__props.showSubscribers && cell(day).subscribers)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(cell(day).subscribers), 1),
                      _createVNode(_unref(ArrowPathRoundedSquareIcon), { class: "h-4 w-4 ml-0.5" })
                    ], 64))
                  : _createCommentVNode("", true),
                (cell(day).warning)
                  ? (_openBlock(), _createBlock(_unref(ExclamationTriangleIcon), {
                      key: 1,
                      class: "h-4 w-4 text-yellow-400 ml-1"
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("time", {
              datetime: _unref(serverDay)(day),
              class: _normalizeClass(["flex h-7 w-7 items-center justify-center rounded-full", currentDay(day) ? 'bg-gray-900 text-white' : 'bg-gray-200'])
            }, _toDisplayString(_unref(dayFormat)(day)), 11, _hoisted_17),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(weekdayFormat)(day)), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["font-mono", __props.hideNumbers && 'blur-sm'])
              }, _toDisplayString(cell(day).total ?? '-'), 3),
              _createElementVNode("div", _hoisted_20, [
                (cell(day).orders)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(cell(day).orders), 1),
                      _createTextVNode(" order" + _toDisplayString(cell(day).orders !== 1 ? 's' : ''), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (cell(day).locations)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(cell(day).locations.with), 1),
                    _createTextVNode(" of " + _toDisplayString(cell(day).locations.of) + " " + _toDisplayString(locationsLabel(cell(day).locations.of)), 1)
                  ]))
                : (__props.showUber && cell(day).pickups)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(cell(day).pickups), 1),
                      _createTextVNode(" pickup" + _toDisplayString(cell(day).pickups !== 1 ? 's' : ''), 1)
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_26, [
                (__props.showSubscribers && cell(day).subscribers)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(cell(day).subscribers), 1),
                      _createVNode(_unref(ArrowPathRoundedSquareIcon), { class: "h-4 w-4 ml-0.5" })
                    ], 64))
                  : _createCommentVNode("", true),
                (cell(day).warning)
                  ? (_openBlock(), _createBlock(_unref(ExclamationTriangleIcon), {
                      key: 1,
                      class: "h-4 w-4 text-yellow-400 ml-1"
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

}